import request from '@/utils/request';

export function queryShopList(data) {
  return request({
    url: '/merchant-info/listShopMerchant',
    method: 'post',
    data,
  });
}

export function queryMerchantInfo(params) {
  return request({
    url: '/merchant-info/getMerchantInfo',
    method: 'get',
    params,
  });
}

export function queryMerchantRate(params) {
  return request({
    url: '/merchant-info/getMerchantRate',
    method: 'get',
    params,
  });
}
